import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { Typography } from '@mui/material'
import ProfileButtons from '../ProfileButtons'
import { useSelector } from 'react-redux'
import { setProfileImage } from '../../../store/reducers/Users/users'
import Standard from '../../../../src/css/images/Standard.svg'
import unverified from '../../../../src/css/images/unverified.svg'
import { ProfileApis } from '../../../API/Login/ProfileApi'
// import ErrorHandle from '../../../Components/ErrorHandle'

const ImageSection = ({ following, followers, buddyList, viewOthers }) => {
  const mainPageUrl = localStorage.getItem('mainPageUrl');
  const { frProUser, emailVerified, numberVerified } = useSelector(
    (state) => state?.Users
  )
  const [updatedFrProUserObj, setUpdatedFrProUserObj] = React.useState(frProUser?.data)
  const [personalDetails, setPersonalDetails] = React.useState()

  const userDefaultProfileImages = () => {
    let mobileNumberObj = {
      fre8ProAccessToken: frProUser?.data?.fre8ProAccessToken,
      // userId: frProUser?.data?.userId,
      // businessId: null,
      // profileId: null,
      clientDeviceType: process.env.REACT_APP_CLIENT_DEVICE_TYPE,
    }
    ProfileApis.getUserDefaultProfileImages(mobileNumberObj)
      .then((res) => {
        // Correct way to merge the objects
        return setUpdatedFrProUserObj({
          ...frProUser,
          profileImages: res?.data?.defaultProfileImageList[0],
        })
        // setMobilePrimaryNumber(res?.data)
      })
      .catch((err) => {
        console.debug('Mobile number not Available', err)
      })
  }

  const getUserPersonalDetailsView = async () => {
    try {
      const token = {
        fre8ProAccessToken: frProUser?.fre8ProAccessToken,
        viewerUserId: frProUser?.userId,
        targetUserId: frProUser?.userId,
        operatedByUserId: process.env.REACT_APP_OPERATED_BY_USER_ID,
        operatedByModule: process.env.REACT_APP_OPERATED_BY_MODULE,
        clientDeviceType: process.env.REACT_APP_CLIENT_DEVICE_TYPE,
      };

      // 🔹 Step 1: Get profile
      const resProfile = await ProfileApis.getUserPersonalDetails(token);

      const userProfileImgObj = {
        fre8ProAccessToken: frProUser?.fre8ProAccessToken,
        userId: frProUser?.userId,
        profileId: resProfile?.data?.profileId,
        operatedByUserId: process.env.REACT_APP_OPERATED_BY_USER_ID,
        operatedByModule: process.env.REACT_APP_OPERATED_BY_MODULE,
        clientDeviceType: process.env.REACT_APP_CLIENT_DEVICE_TYPE,
      };

      // 🔹 Step 2: Get profile image
      const resImg = await ProfileApis.userProfileImage(userProfileImgObj);

      setPersonalDetails(resProfile?.data)
      return setUpdatedFrProUserObj({
        ...frProUser,
        profileImages: resImg?.data?.profileImageUrlList?.at(-1) || '',
      })
      // 🔹 Step 3: Construct the new user object safely
      // const updatedUser = {
      //   ...userObj,
      //   updateProfileForm: resProfile?.data,
      //   updateProfileFormNew: resProfile?.data,
      //   profileImg: resImg?.data?.profileImageUrlList?.at(-1) || '',
      //   profileId: resProfile?.data?.profileId,
      // };

      // 🔹 Step 4: Update both local and global state
      // setprofileData(updatedUser);

      // dispatch(
      //   setFrProUser({
      //     frProUser: updatedUser,
      //   })
      // );

    } catch (err) {
      console.error('Error in getUserProfile:', err);

      // let customMessage = 'User profile details failed';
      // let type = 'User Information';
      // let color = 'red';
      // ErrorHandle(err, setToasts, customMessage, type, color);
    }
  };

  // const getUserPersonalDetailsView = () => {
  //   let mobileNumberObj = {
  //     fre8ProAccessToken: frProUser?.fre8ProAccessToken,
  //     viewerUserId: frProUser?.userId,
  //     targetUserId: frProUser?.userId,
  //     operatedByUserId: process.env.REACT_APP_OPERATED_BY_USER_ID,
  //     operatedByModule: process.env.REACT_APP_OPERATED_BY_MODULE,
  //     clientDeviceType: process.env.REACT_APP_CLIENT_DEVICE_TYPE,
  //   }
  //   ProfileApis.getUserPersonalDetails(mobileNumberObj)
  //     .then((res) => {
  //       // Correct way to merge the objects
  //       console.log('------------------Correct way to merge the objects-------------', res)
  //       setPersonalDetails(res?.data)
  //       // return setUpdatedFrProUserObj({
  //       //   ...frProUser,
  //       //   profileImages: res?.data?.defaultProfileImageList[0],
  //       // })
  //       // setMobilePrimaryNumber(res?.data)
  //     })
  //     .catch((err) => {
  //       console.debug('Mobile number not Available', err)
  //     })
  // }

  React.useEffect(() => {
    userDefaultProfileImages()
    getUserPersonalDetailsView()
    // userPersonalDetailsByUserId()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className="align-items-start d-flex justify-content-between mb-5 flex-wrap">
      <div>
        <div className="d-flex">
          <div className="image-holder-main position-relative">
            <div className="image-holder overflow-hidden position-relative">
              <img
                src={updatedFrProUserObj?.profileImages ? updatedFrProUserObj?.profileImages : setProfileImage}
                alt="profileImage"
                height={160}
                width={160}
                style={{ objectFit: 'cover' }}
              />
            </div>
          </div>
          <div className="px-4">
            <div className='d-flex align-items-center gap-1'>
              <button
                title="Fre8ProStatus"
                className="driver-btn text-middle d-flex align-items-center gap-1"
                type="button">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="10"
                  height="10"
                  viewBox="0 0 10 10"
                  fill="none">
                  <circle cx="5" cy="5" r="4" fill="#12B76A" />
                </svg>{' '}
                {personalDetails?.fre8ProStatus}
              </button>
              {emailVerified && numberVerified ? (
                <button type="button">
                  <img src={Standard} alt="Standard" />
                </button>
              ) : (
                <button type="button">
                  <img src={unverified} alt="unverified" />
                </button>
              )}
            </div>

            <h4 className="mt-2 text-capitalize">
              {personalDetails?.personalInfoForm?.firstName}{' '}
              {personalDetails?.personalInfoForm?.lastName}
            </h4>
            {console.log('-------personalDetails e3234-----', personalDetails)}
            <p className="mb-0 small text-muted">
              {personalDetails?.personalTaglineForm?.tagline
                ? personalDetails?.personalTaglineForm?.tagline
                : 'No tag line added'}
            </p>
          </div>
        </div>
      </div>
      <div className="shadow-sm p-4 rounded-4 me-4 bg-white bg-white">
        {mainPageUrl && <div className="text-theme mb-3">
          <span className="me-3 fw-medium">{buddyList?.length || 0} Buddies</span>
          <span className="me-3 fw-medium">{followers?.length || 0} Followers</span>
          <span className="fw-medium">{following?.length || 0} Following</span>
        </div>}
        {viewOthers ? (
          <ProfileButtons></ProfileButtons>
        ) : (
          <Typography
            component={Link}
            to="/updateprofile"
            className="btn custom-button w-100">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="21"
              height="20"
              viewBox="0 0 21 20"
              fill="none">
              <path
                d="M14.6665 2.49993C14.8854 2.28106 15.1452 2.10744 15.4312 1.98899C15.7171 1.87054 16.0236 1.80957 16.3332 1.80957C16.6427 1.80957 16.9492 1.87054 17.2352 1.98899C17.5211 2.10744 17.781 2.28106 17.9998 2.49993C18.2187 2.7188 18.3923 2.97863 18.5108 3.2646C18.6292 3.55057 18.6902 3.85706 18.6902 4.16659C18.6902 4.47612 18.6292 4.78262 18.5108 5.06859C18.3923 5.35455 18.2187 5.61439 17.9998 5.83326L6.74984 17.0833L2.1665 18.3333L3.4165 13.7499L14.6665 2.49993Z"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"></path>
            </svg>{' '}
            Edit my profile
          </Typography>
        )}
      </div>
    </div>
  )
}

ImageSection.propTypes = {
  following: PropTypes.any,
  followers: PropTypes.any,
  buddyList: PropTypes.array,
  viewOthers: PropTypes.bool,
}

export default ImageSection
